import { render, staticRenderFns } from "./Submissions.vue?vue&type=template&id=91290fc8"
import script from "./Submissions.vue?vue&type=script&lang=js"
export * from "./Submissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports